import ajax from '@/utils/request'

// #region 待办业务管理
/**
 * @description 审批意见查询
 * @param {*} params
 * @returns
 */
export function getApprovalOpinionList(params) {
  return ajax.post({
    url: '/erpreform/check-opinion/page/v100',
    params
  })
}

/**
 * @description 审批意见记录
 * @param {*} params
 * @returns
 */
export function getApprovalOpinionRecords(params) {
  return ajax.post({
    url: '/erpreform/check-opinion/records/v100',
    params
  })
}

/**
 * @description 审批人搜索
 * @param {*} params
 * @returns
 */
export function getApproverList(params) {
  return ajax.post({
    url: '/erpreform/check-opinion/approver-search/v100',
    params
  })
}

/**
 * @description 已办事项查询
 * @param {*} params
 * @returns
 */
export function getDomeItemsList(params) {
  return ajax.post({
    url: '/erpreform/wf-done-task/page/v100',
    params
  })
}

/**
 * @description 已办事项记录
 * @param {Object} params
 * @param {number} params.instanceId 工作流实例ID
 * @returns
 */
export function getDomeItemsRecords(params) {
  return ajax.post({
    url: '/erpreform/wf-done-task/approval-records/v100',
    params
  })
}

/**
 * @description 单据类型列表
 * @param {*} params
 * @returns
 */
export function getBillTypeList(params) {
  return ajax.post({
    url: '/erpreform/wf-done-task/bill-type-options/v100',
    params
  })
}

let billTypeLoadPromise = null
let billTypeOptionsCache = []

function mapBillTypeOptions(data) {
  return (Array.isArray(data) ? data : [])
    .filter((item) => item && item.prefix)
    .map((item) => ({
      label: item.prefixDesc,
      value: item.prefix,
      defaultSelected: !!item.defaultSelected
    }))
}

export function getDefaultBillTypeValue(options) {
  const list = options && options.length ? options : billTypeOptionsCache
  if (!list || !list.length) return ''
  const hit = list.find((item) => item && item.defaultSelected)
  return hit ? hit.value : list[0].value
}

/** 进入「待办业务管理」后加载已办单据类型，页面复用同一 Promise，避免重复请求 */
export function prefetchBillTypeList() {
  if (billTypeLoadPromise) return billTypeLoadPromise
  billTypeLoadPromise = getBillTypeList()
    .then(({ data }) => {
      billTypeOptionsCache = mapBillTypeOptions(data)
      return billTypeOptionsCache
    })
    .catch((error) => {
      billTypeLoadPromise = null
      console.error('获取单据类型列表失败', error)
      return []
    })
  return billTypeLoadPromise
}

export function ensureBillTypeList() {
  return prefetchBillTypeList()
}

export function clearBillTypeList() {
  billTypeLoadPromise = null
  billTypeOptionsCache = []
}
// #endregion

// #region 首营管理
/**
 * @description 资料修改审批查询
 * @param {*} params
 * @returns
 */
export function getMaterialModificationList(params) {
  return ajax.post({
    url: '/erpreform/data-mod-approval/page/v100',
    params
  })
}

/**
 * @description 资料修改审批详情
 * @param {*} params
 * @returns
 */
export function getMaterialModificationDetail(params) {
  return ajax.post({
    url: '/erpreform/data-mod-approval/detail/v100',
    params
  })
}

/**
 * @description 申请人|审批人列表
 * @param {*} params
 * @returns
 */
export function getApplicantList(params) {
  return ajax.post({
    url: '/erpreform/data-mod-approval/search-staff-doc/v100',
    params
  })
}

/**
 * @description 公司列表
 * @param {*} params
 * @returns
 */
export function getOrgList(params) {
  return ajax.post({
    url: '/erpreform/data-mod-approval/search-by-company/v100',
    params
  })
}

/**
 * @description 部门列表
 * @param {*} params
 * @returns
 */
export function getDeptList(params) {
  return ajax.post({
    url: '/erpreform/data-mod-approval/search-by-department/v100',
    params
  })
}

/**
 * @description 商品列表
 * @param {*} params
 * @returns
 */
export function getGoodsList(params) {
  return ajax.post({
    url: '/erpreform/data-mod-approval/search-by-goods-name/v100',
    params
  })
}

/**
 * @description 中台客户变更审批查询
 * @param {*} params
 * @returns
 */
export function getZtClientChangeList(params) {
  return ajax.post({
    url: '/erpreform/zt-client-info-change-audit/records/page/v100',
    params
  })
}

/**
 * @description 中台客户变更审批详情
 * @param {*} params
 * @returns
 */
export function getZtClientChangeDetail(params) {
  return ajax.post({
    url: '/erpreform/zt-client-info-change-audit/detail/v100',
    params
  })
}

/**
 * @description 中台商品变更审批查询
 * @param {*} params
 * @returns
 */
export function getZtGoodsChangeList(params) {
  return ajax.post({
    url: '/erpreform/zt-goods-info-change-audit/records/page/v100',
    params
  })
}

/**
 * @description 中台商品变更审批详情
 * @param {*} params
 * @returns
 */
export function getZtGoodsChangeDetail(params) {
  return ajax.post({
    url: '/erpreform/zt-goods-info-change-audit/detail/v100',
    params
  })
}

/**
 * @description 中台商品模糊搜索
 * @param {*} params
 * @returns
 */
export function fuzzySearchZtProduct(params) {
  return ajax.post({
    url: '/erpreform/zt-goods-info-change-audit/fuzzy-search/name-code/v100',
    params
  })
}

/**
 * @description 中台供应商变更审批查询
 * @param {*} params
 * @returns
 */
export function getZtSupplierChangeList(params) {
  return ajax.post({
    url: '/erpreform/zt-supply-info-change-audit/records/page/v100',
    params
  })
}

/**
 * @description 中台供应商变更审批详情
 * @param {*} params
 * @returns
 */
export function getZtSupplierChangeDetail(params) {
  return ajax.post({
    url: '/erpreform/zt-supply-info-change-audit/detail/v100',
    params
  })
}

// #endregion

// #region 基础资料查询
/**
 * @description 客户/供应商记录汇总
 * @param {*} params
 * @param {number} params.queryType 1-客户停售/恢复记录 2-客户冻结/解冻记录 3-供应商冻结/解冻记录 4-供应商停止/恢复采购记录
 * @returns
 */
export function getErpCustomerSupplierSummaryRecord(params) {
  return ajax.post({
    url: '/erpreform/client-supplier-record/summary/page/v100',
    params
  })
}

/**
 * @description 客户/供应商记录明细
 * @param {*} params
 * @param {number} params.queryType 1-客户停售/恢复记录 2-客户冻结/解冻记录 3-供应商冻结/解冻记录 4-供应商停止/恢复采购记录
 * @returns
 */
export function getErpCustomerSupplierDetailRecord(params) {
  return ajax.post({
    url: '/erpreform/client-supplier-record/detail/page/v100',
    params
  })
}

/**
 * @description 商品停采/恢复记录汇总
 * @param {*} params
 * @returns
 */
export function getErpProductStopRestoreSummaryRecord(params) {
  return ajax.post({
    url: '/erpreform/goods-stop-resume-record/summary/page/v100',
    params
  })
}

/**
 * @description 商品停采/恢复记录明细
 * @param {*} params
 * @returns
 */
export function getErpProductStopRestoreDetailRecord(params) {
  return ajax.post({
    url: '/erpreform/goods-stop-resume-record/detail/page/v100',
    params
  })
}

/**
 * @description 商品冻结/解冻记录汇总
 * @param {*} params
 * @returns
 */
export function getErpProductFrozenUnfrozenSummaryRecord(params) {
  return ajax.post({
    url: '/erpreform/goods-freeze-unfreeze-record/summary/page/v100',
    params
  })
}

/**
 * @description 商品冻结/解冻记录明细
 * @param {*} params
 * @returns
 */
export function getErpProductFrozenUnfrozenDetailRecord(params) {
  return ajax.post({
    url: '/erpreform/goods-freeze-unfreeze-record/detail/page/v100',
    params
  })
}

/**
 * @description 商品停售/恢复记录汇总
 * @param {*} params
 * @returns
 */
export function getErpProductStopSaleRestoreSummaryRecord(params) {
  return ajax.post({
    url: '/erpreform/goods-stop-sale-resume-record/summary/page/v100',
    params
  })
}

/**
 * @description 商品停售/恢复记录明细
 * @param {*} params
 * @returns
 */
export function getErpProductStopSaleRestoreDetailRecord(params) {
  return ajax.post({
    url: '/erpreform/goods-stop-sale-resume-record/detail/page/v100',
    params
  })
}
// #endregion

// #region 质量管控查询
/**
 * @description 首营商品一览表
 * @param {*} params
 * @returns
 */
export function getQcFirstProductOverviewList(params) {
  return ajax.post({
    url: '/erpreform/goods-first-camp-overview/records/page/v100',
    params
  })
}

/** 下载首营商品审批导入模板（Excel） */
export const firstProductOverviewImportTemplateUrl = '/erpreform/goods-first-camp-overview/import-template/v100'

/** 首营商品一览表-导出 */
export const firstProductOverviewExportUrl =
  '/erpreform/goods-first-camp-overview/records/export/v100'

/**
 * @description 首营商品一览表-批量导入
 * @param {*} params
 * @returns
 */
export function importFirstProductOverview(params) {
  return ajax.upload(
    {
      url: '/erpreform/goods-first-camp-overview/import/v100',
      params
    },
    {
      rewrite: 'post'
    }
  )
}

/**
 * @description 首营品种审批表预览数据
 * @param {*} params
 * @returns
 */
export function getFirstProductOverviewPreviewData(params) {
  return ajax.post({
    url: '/erpreform/goods-first-camp-overview/records/approval-preview/v100',
    params
  })
}

/**
 * @description 客商一览表
 * @param {*} params
 * @returns
 */
export function getMerchantOverviewList(params) {
  return ajax.post({
    url: '/erpreform/business-partner-overview/records/page/v100',
    params
  })
}

/**
 * @description 客商一览表-证书信息
 * @param {Object} params
 * @param {string} params.businessId 单位Id
 * @param {string} params.companyName 公司名称（与列表「公司」一致）
 * @returns
 */
export function getMerchantOverviewCerts(params) {
  return ajax.post({
    url: '/erpreform/business-partner-overview/records/certificates/v100',
    params
  })
}

/** 客商一览表-导出 */
export const merchantOverviewExportUrl =
  '/erpreform/business-partner-overview/records/export/v100'

/**
 * @description 首营客户一览表-客户资质审核表预览数据
 * @param {*} params
 * @returns
 */
export function getCustomerOverviewPreviewData(params) {
  return ajax.post({
    url: '/erpreform/business-partner-overview/records/client-qualification-preview/v100',
    params
  })
}

/**
 * @description 首营客户一览表-客户质量体系调查表预览数据
 * @param {*} params
 * @returns
 */
export function getCustomerQualSurveyFormPreviewData(params) {
  return ajax.post({
    url: '/erpreform/business-partner-overview/records/client-quality-system-survey/v100',
    params
  })
}

/**
 * @description 资质变更查询
 * @param {*} params
 * @returns
 */
export function getQualificationChangeQueryList(params) {
  return ajax.post({
    url: '/erpreform/qualification-change-overview/records/page/v100',
    params
  })
}

/**
 * @description 资质变更查询-按单据查询变更证书
 * @param {*} params
 * @returns
 */
export function getQualificationChangeRecords(params) {
  return ajax.post({
    url: '/erpreform/qualification-change-overview/records/cert-changes/v100',
    params
  })
}

/**
 * @description 客户一览表
 * @param {*} params
 * @returns
 */
export function getCustomerOverviewList(params) {
  return ajax.post({
    url: '/erpreform/customer-overview/records/page/v100',
    params
  })
}

/**
 * @description 客户一览表-证书信息
 * @param {Object} params
 * @param {string} params.businessId 单位Id
 * @param {string} params.companyName 公司名称（与列表「公司」一致）
 * @returns
 */
export function getCustomerOverviewCerts(params) {
  return ajax.post({
    url: '/erpreform/customer-overview/records/certificates/v100',
    params
  })
}
/** 下载《首营客户一览表导入模板》 */
export const firstCustomerOverviewImportTemplateUrl = '/erpreform/customer-overview/import-template/v100'

/** 客户一览表-导出 */
export const customerOverviewExportUrl = '/erpreform/customer-overview/records/export/v100'

/**
 * @description 首营客户一览表-批量导入
 * @param {*} params
 * @returns
 */
export function importFirstCustomerOverview(params) {
  return ajax.upload(
    {
      url: '/erpreform/customer-overview/import/v100',
      params
    },
    {
      rewrite: 'post'
    }
  )
}

/**
 * @description 供应商一览表
 * @param {*} params
 * @returns
 */
export function getSupplierOverviewList(params) {
  return ajax.post({
    url: '/erpreform/supplier-overview/records/page/v100',
    params
  })
}

/**
 * @description 供应商一览表-证书信息
 * @param {Object} params
 * @param {string} params.businessId 单位Id
 * @param {string} params.companyName 公司名称（与列表「公司」一致）
 * @returns
 */
export function getSupplierOverviewCerts(params) {
  return ajax.post({
    url: '/erpreform/supplier-overview/records/certificates/v100',
    params
  })
}

/** 下载《首营供应商一览表导入模板》（Excel，12 列） */
export const supplierOverviewImportTemplateUrl = '/erpreform/supplier-overview/import-template/v100'

/** 供应商一览表-导出 */
export const supplierOverviewExportUrl = '/erpreform/supplier-overview/records/export/v100'

/**
 * @description 首营供应商一览表-批量导入
 * @param {*} params
 * @returns
 */
export function importSupplierOverview(params) {
  return ajax.upload(
    {
      url: '/erpreform/supplier-overview/import/v100',
      params
    },
    {
      rewrite: 'post'
    }
  )
}

/**
 * @description 供应商一览表-《首营企业及销售人员审核表》预览数据
 * @param {*} params
 * @returns
 */
export function getSupplierOverviewPreviewData(params) {
  return ajax.post({
    url: '/erpreform/business-partner-overview/records/enterprise-sales-audit-preview/v100',
    params
  })
}
// #endregion
